"use client";
import { useState } from "react";

const useModalController = (hideBodyScroll = true) => {
    const [isOpen, setIsOpen] = useState(false);

    const open = () => {
        setIsOpen(true);
        if (hideBodyScroll) {
            document.body.style.overflow = "hidden";
        }
    };
    const close = () => {
        setIsOpen(false);
        if (hideBodyScroll) {
            document.body.style.overflow = "auto";
        }
    };

    return { isOpen, open, close };
};

export { useModalController };
